﻿{
  "version": 1,
  "gameId": "chahar-barg",
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "chahar-barg.rules.navigationLabel",
    "kickerKey": "chahar-barg.rules.kicker",
    "titleKey": "chahar-barg.rules.title",
    "summaryKey": "chahar-barg.rules.summary",
    "sections": [
      { "id": "setup", "key": "chahar-barg.rules.setup" },
      { "id": "turn", "key": "chahar-barg.rules.turn" },
      { "id": "capture", "key": "chahar-barg.rules.capture" },
      { "id": "jack", "key": "chahar-barg.rules.jack" },
      { "id": "sur", "key": "chahar-barg.rules.sur" },
      { "id": "scoring", "key": "chahar-barg.rules.scoring" },
      { "id": "finish", "key": "chahar-barg.rules.finish" },
      { "id": "modes", "key": "chahar-barg.rules.modes" }
    ],
    "settingsAccess": false
  },
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "cosmetics": {}
}
